import React, { createContext, useContext, PropsWithChildren } from 'react';

type DisableState = {
  isDisabled?: boolean;
  omitFields?: Set<string>;
  reason?: string;
  getDisabled?: (name: string) => boolean;
};

const DisableContext = createContext<DisableState>({});

type Props = {
  isDisabled: boolean;
  omitFields?: string[];
  reason?: string;
};

export const DisableProvider = ({
  children,
  isDisabled,
  omitFields,
  reason,
}: PropsWithChildren<Props>) => {
  const omitSet = new Set(omitFields);
  const getDisabled = (name: string) => {
    if (!isDisabled) return false;
    return !omitSet.has(name);
  };
  return (
    <DisableContext.Provider
      value={{
        isDisabled,
        omitFields: new Set(omitFields),
        getDisabled,
        reason,
      }}
    >
      {children}
    </DisableContext.Provider>
  );
};

export const useDisabled = () => useContext(DisableContext) || {};
